// Instrument readouts (RESTYLE §3): the live cockpit's counters (events · processes · hosts · injections · dumps).
//   <Readouts items label? className? />
//       items: { label, value, unit?, mark?, key? }[] — mono 300 tabular numerals over mono caps labels;
//       a value of 0 reads faint; `mark` puts a category shape before the label (process, network, memory …)
import type { ReactNode } from "react";
import { CatMark, type Category } from "./Glyphs";
import { cx } from "./cx";

export type ReadoutItem = { label: string; value: ReactNode; unit?: ReactNode; mark?: Category; key?: string };

export function Readouts({ items, label = "Counters", className }: { items: readonly ReadoutItem[]; label?: string; className?: string }) {
  return (
    <dl className={cx("readouts", className)} aria-label={label}>
      {items.map((r) => (
        <div key={r.key ?? r.label} className="readout flex flex-col-reverse" data-zero={r.value === 0 ? "" : undefined}>
          <dt className="readout-l">
            {r.mark && <CatMark c={r.mark} />}
            {r.label}
          </dt>
          <dd className="readout-n">
            {r.value}
            {r.unit !== undefined && r.unit !== null && <small>{r.unit}</small>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
